<template>
  <layout :title="$route.name" :options="options">
    <v-dialog
      :width="$vuetify.breakpoint.smAndDown ? '100%' : '700'"
      v-model="modalwithdrawInfo"
    >
      <v-container style="background-color: #f2f2f2;" v-if="modalwithdrawInfo">
        <!-- Título -->
        <v-row>
          <v-col cols="12">
            <span class="fonte">Solicitação de Saque</span>
          </v-col>
        </v-row>

        <!-- Saldo atual -->
        <v-row>
          <v-col cols="12">
            <v-card outlined class="pa-4">
              <v-card-title class="subtitle-1 font-weight-bold">Saldo Atual</v-card-title>
              <v-card-text v-if="user.total_value_investment">
                <!-- <div class="display-1 font-weight-bold">R$ 0,00</div> -->
                <div class="display-1 font-weight-bold"> {{ $helper.formataSaldo(user.total_value_investment.balance) }} </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Informações do usuário -->
        <v-row>
          <v-col cols="12" md="6">
            <v-card outlined height="200">
              <v-card-title class="subtitle-1 font-weight-bold">Informações do Usuário</v-card-title>
              <v-card-text>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title><strong>Nome:</strong> {{ withdraw.user.name }}</v-list-item-title>
                      <v-list-item-title><strong>Email:</strong> {{ withdraw.user.email }}</v-list-item-title>
                      <v-list-item-title><strong>Telefone:</strong> {{ withdraw.user.phone }}</v-list-item-title>
                      <v-list-item-title><strong>CPF:</strong> {{ withdraw.user.cpf }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Dados da Solicitação -->
          <v-col cols="12" md="6">
            <v-card outlined height="200">
              <v-card-title class="subtitle-1 font-weight-bold">Dados da Solicitação</v-card-title>
              <v-card-text>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title><strong>Descrição:</strong> {{ withdraw.description }}</v-list-item-title>
                      <v-list-item-title><strong>Valor:</strong> R$ {{ withdraw.value }}</v-list-item-title>
                      <v-list-item-title><strong>Método:</strong> {{ withdraw.payment_method.bank }} - {{ withdraw.payment_method.info }}</v-list-item-title>
                      <v-list-item-title><strong>Pix/Conta:</strong> {{ withdraw.payment_method.pix_type }}</v-list-item-title>
                      <v-list-item-title><strong>Status Atual:</strong> {{ withdraw.current_status }}</v-list-item-title>
                      <v-list-item-title><strong>Data do Pedido:</strong> {{ $moment(withdraw.created_at).format("DD/MM/YYYY") }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Histórico de Status -->
        <v-row>
          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="subtitle-1 font-weight-bold">Histórico de Status</v-card-title>
              <v-card-text>
                <v-timeline dense>
                  <v-timeline-item
                    v-for="(s, index) in withdraw.status"
                    :key="index"
                    color="blue"
                    small
                  >
                    <v-card class="pa-3">
                      <div><strong>Status:</strong> {{ s.status }}</div>
                      <div><strong>Data:</strong> {{ $moment(s.date).format("DD/MM/YYYY") }}</div>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <div v-if="
                  withdraw.current_status === 'aguardando pagamento'
                " class="expande-horizontal py-3 centraliza">
          <v-btn
                @click="
                  createConfirmAction({
                    icon: 'mdi-check',
                    message: 'Aprovar Este Saque?',
                    action: 'approveRequestPayment',
                    action_value: withdraw
                  }), modalwithdrawInfo = false;
                "
                v-if="withdraw.current_status !== 'active'"
                small
                class="fonte mr-2"
                outlined
                :color="$theme.primary"
              >
                aprovar
              </v-btn>
              <v-btn
                @click="
                  createConfirmAction({
                    icon: 'mdi-check',
                    message: 'Cancelar Este Saque?',
                    action: 'cancelRequestPayment',
                    action_value: withdraw
                  }), modalwithdrawInfo = false;
                "
                small
                class="fonte"
                outlined
                color="red"
              >
                recusar
              </v-btn>
        </div>
      </v-container>
    </v-dialog>
    <v-flex xs12>
      <div class="expande-horizontal pa-3 pb-1 mt-1">
        <v-flex xs12 md3>
          <v-select
            dark
            label="Status"
            hide-details
            placeholder="Filtrar por Status"
            outlined
            dense
            item-text="text"
            item-value="value"
            @change="search"
            v-model="filters.current_status"
            :items="[
              {
                text: 'Aguardando Pagamento',
                value: 'aguardando pagamento'
              },
              {
                text: 'Aprovados',
                value: 'active'
              },
              {
                text: 'Recusados',
                value: 'cenceled'
              }
            ]"
          ></v-select>
         </v-flex>
      </div>
    </v-flex>
    <v-flex xs12 class="pa-3">
      <v-simple-table v-if="$vuetify.breakpoint.lgAndUp">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left fonte">
                Cliente
              </th>
              <th class="text-left fonte">
                Valor do saque
              </th>
              <th class="text-left fonte">
                Data
              </th>
              <th class="text-left fonte">
                Status
              </th>
              <th class="text-left fonte">
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in getRequestPayments" :key="item._id">
              <td class="font-weight-bold">{{ item.user.name }}</td>
              <td class="font-weight-bold green--text">{{ $helper.formataSaldo(item.value) }}</td>
              <td class="font-weight-bold">
                {{ $moment(item.created_at).format("DD/MM/YYYY [às] HH:mm") }}
              </td>
              <td class="font-weight-bold">
                {{
                  item.current_status === "active"
                    ? "pago"
                    : item.current_status
                }}
              </td>
              <td class="font-weight-bold">
                <v-btn small class="fonte" dark color="blue" @click="openWithdrawInfo(item)">Ver</v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-list
        v-else
        dark
        style="border-radius: 6px;"
        class="pa-0 ma-0"
        dense
        three-line
      >
        <template v-for="(item, index) in getRequestPayments">
          <v-list-item :key="item._id">
            <v-list-item-content>
              <v-list-item-title class="fonte">
                Cliente: {{ item.user.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="fonte">
                Banco: {{ item.withdraw_info ? item.withdraw_info.bank : "" }} -
                {{ item.transaction_type | filterRequestPaymentType }} -
                {{ item.withdraw_info ? item.withdraw_info.info : "" }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="fonte">
                {{ item.value }} - {{ item.current_status }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="fonte">
                {{ $moment(item.created_at).format("DD/MM/YYYY [às] HH:mm") }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn class="fonte" dark color="blue" @click="openWithdrawInfo(item)">ver</v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="index"></v-divider>
        </template>
      </v-list>

      <div v-if="getRequestPayments.length === 0" class="expande-horizontal centraliza" style="min-height: 30vh; background: #444; border-radius: 12px; color: #f2f2f2; margin-top: 6px; ">
        <h3 class="fonte">Nenhum saque encontrado</h3>
      </div>
    </v-flex>
  </layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      options: [],
      modalwithdrawInfo: false,
      user: {},
      withdraw: {
        user: {}
      },
      filters: {
        current_status: 'aguardando pagamento'
      }
    };
  },
  filters: {
    filterRequestPaymentType(val) {
      const types = {
        unilevel: "REDE",
        investment: "INVESTIMENTO"
      };
      return types[val];
    }
  },
  computed: {
    ...mapGetters(["getRequestPayments"])
  },
  methods: {
    ...mapActions(["listRequestPayments", "createConfirmAction", "viewUser"]),
    async openWithdrawInfo(item) {
      try {
        await this.viewUser({ _id: item.user._id }).then(res => {
          this.user = res
          this.modalwithdrawInfo = true;
          this.withdraw = item;
        })
      } catch (error) {
        alert('erro ao visualizar usuário')
      }
    },
    search() {
      this.listRequestPayments({ filters: this.filters });
    }
  },
  created() {
    this.search();
  }
};
</script>
